<template>
  <div>
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <div class="text-center">
          <h3 class="mb-4">
            Scheduler Settings
          </h3>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-card class="">
          <v-card-text class="pa-4 ">
            <div class="d-flex justify-space-between">
              <div class="pr-4">
                <h5 class="text-18 ">
                  Priority Auto-Scheduling
                </h5>
                <p class="">
                  <i>Auto-scheduling based on the time of content arrival.</i> High priority assets are scheduled first. The range of asset priorities is 1 to 10, with 1 being the lowest priority and 10 being the highest.
                  <i>Minimum repetition interval</i> means repeating an asset no more often than after N other assets.
                </p>
              </div>
            </div>
            <v-simple-table class="transparent">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left pl-0 text-body-2">
                      ASSET ARRIVAL TIME
                    </th>
                    <th class="text-center pl-0 text-body-2">
                      MIN REP INTERVAL
                    </th>
                    <th class="text-center pr-0 text-body-2">
                      PRIORITY
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="rule in scheduleRules"
                    :key="rule.id"
                    class="hover:transparent"
                  >
                    <td
                      class="text-body-1 pl-0"
                    >
                      {{ rule.desc }}
                    </td>
                    <td
                      class="text-center text-body-1 pl-0"
                    >
                      {{ rule.distance }}
                    </td>
                    <td
                      class="text-center font-weight-bold text-body-1 pr-0 text-primary"
                    >
                      {{ rule.weight }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions
            class="primary--text grey lighten-5 py-4 text--pointer"
            disabled
          >
            Manage intervals
          </v-card-actions>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-card class="h-full">
          <v-card-title class="d-flex justify-space-between">
            <div class="mb-0 mr-4">
              <p class="card-title mb-0">
                Asset Distribution by Arrival Time
              </p>
            </div>
          </v-card-title>
          <v-card-text>
            <div
              id="basicArea-chart"
              style="min-height: 300px"
            >
              <apexchart
                type="bar"
                height="350"
                :options="chartOptions"
                :series="chartOptions.series"
              />
            </div>
            <p>
              <span class="font-weight-bold">Total assets</span> {{ totalAssets }}<br>
              <span class="font-weight-bold">Out of intervals</span> {{ outOfRules }}
            </p>
          </v-card-text>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <v-card-text class="pa-4">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex">
                  <v-img
                    max-width="40"
                    max-height="40"
                    class=" mr-4"
                    src="@/assets/images/calendar.svg"
                    alt=""
                  />
                  <p class="font-weight-medium text-h5 mb-0">
                    Forward scheduling depth
                  </p>
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex">
                  <v-icon
                    color="primary"
                    class="mr-3"
                  >
                    mdi-timer
                  </v-icon>
                  <p class="font-weight-medium mb-0">
                    {{ channel.autoSchedulerDepthStr }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions
            class="primary--text grey lighten-5 py-4"
            style="cursor:pointer2"
            disabled
          >
            Manage scheduling depth
          </v-card-actions>
        </base-card>
      </v-col>
    </v-row>
    <!-- Edit Form  -->
    <v-dialog
      v-model="dialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Ads Settings</span>
        </v-card-title>
        <template v-if="!preSaveMsg">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    v-model="advertising"
                    hide-details
                  >
                    <template v-slot:label>
                      <div>
                        Advertising
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-form ref="form1">
                <v-row v-if="advertising">
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="adBlockDuration"
                      label="Ad-block duration*"
                      type="number"
                      prepend-icon="mdi-clock"
                      hint="max 10 min"
                      suffix="min"
                      step="0.5"
                      :rules="rules.durationRules"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="minInterval"
                      label="Minimum interval between ads*"
                      suffix="min"
                      prepend-icon="mdi-arrow-expand-horizontal"
                      type="number"
                      hint="min 3 min, max 10 min"
                      :rules="rules.intervalRules"
                      step="0.5"
                    />
                  </v-col>
                </v-row>
              </v-form>
              <v-row v-if="advertising">
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    v-model="inContentAdvertising"
                    hide-details
                  >
                    <template v-slot:label>
                      <div>
                        In-content advertising
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-form ref="form2">
                <v-row v-if="inContentAdvertising">
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="programSafeZoneLeft"
                      type="number"
                      label="Asset safe zone left*"
                      prepend-icon="mdi-arrow-collapse-right"
                      hint="max 10 min"
                      suffix="min"
                      step="0.5"
                      :rules="rules.zoneRules"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="programSafeZoneRight"
                      type="number"
                      suffix="min"
                      append-outer-icon="mdi-arrow-collapse-left"
                      label="Asset safe zone right*"
                      hint="max 10 min"
                      step="0.5"
                      :rules="rules.zoneRules"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="closeDialog"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              :disabled="loading || !isFormValid"
              @click="showPreSaveMsg()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </template>
        <template v-else>
          <v-card-text>
            <v-alert
              outlined
              type="warning"
              prominent
              border="left"
            >
              Apply changes
              <v-radio-group
                v-model="updateSchedule"
                column
              >
                <v-radio
                  label="to the current schedule (delete and create a new one from the current moment)"
                  color="red"
                  value="all"
                />
                <v-radio
                  label="only to the new schedule"
                  color="success"
                  value="new"
                />
              </v-radio-group>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="preSaveMsg = false"
            >
              Back
            </v-btn>
            <v-btn
              color="primary"
              :disabled="loading || !isFormValid"
              @click="saveEditForm()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { processChannel } from '@/store/converters'

  export default {
    data () {
      return {
        channel: {
          id: 0,
          ads: {},
        },
        dialog: false,
        advertising: true,
        inContentAdvertising: true,
        adBlockDuration: 2,
        minInterval: 7,
        programSafeZoneLeft: 3,
        programSafeZoneRight: 3,
        isSaving: false,
        preSaveMsg: false,
        updateSchedule: 'new',
        rules: {
          durationRules: [
            v => !!v || 'Duration is required',
            v => (v >= 0 && v <= 10) || 'Duration must be between 0 and 10 min',
          ],
          intervalRules: [
            v => !!v || 'Interval is required',
            v => (v >= 3 && v <= 10) || 'Interval must be between 3 and 10 min',
          ],
          zoneRules: [
            v => !!v || 'Value is required',
            v => (v >= 0 && v <= 10) || 'Value must be between 0 and 10 min',
          ],
        },
        scheduleRules: [],
        totalAssets: 0,
        outOfRules: 0,
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
            height: 350,
            type: 'bar',

          },
          colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8', '#0084ff', '#39539E', '#0077B5'],
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          series: [],
          yaxis: {
            title: {
              text: 'assets',
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8', '#0084ff', '#39539E', '#0077B5'],
                fontSize: '14px',
              },
            },
          },
        },
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (this.advertising) {
          if (this.adBlockDuration < 0 || this.adBlockDuration > 10) {
            return false
          }
          if (this.minInterval < 3 || this.minInterval > 10) {
            return false
          }
        }
        if (this.adBlockDuration) {
          if (this.programSafeZoneLeft < 0 || this.programSafeZoneLeft > 10) {
            return false
          }
          if (this.programSafeZoneRight < 0 || this.programSafeZoneRight > 10) {
            return false
          }
        }
        return true
      },
    },
    created () {
      const channelId = this.$route.params.id
      this.channel.id = channelId

      this.getChannelInfo(channelId)
    },
    methods: {
      initSettings () {
        this.advertising = this.channel.ads.adBlockDuration > 0
        this.inContentAdvertising = this.channel.ads.inContentAdvertising
        if (this.channel.ads.adBlockDuration) {
          this.adBlockDuration = this.channel.ads.adBlockDuration % 60 === 0 ? this.channel.ads.adBlockDuration / 60 : Number((this.channel.ads.adBlockDuration / 60).toFixed(1))
        }
        if (this.channel.ads.minInterval) {
          this.minInterval = this.channel.ads.minInterval % 60 === 0 ? this.channel.ads.minInterval / 60 : Number((this.channel.ads.minInterval / 60).toFixed(1))
        }
        if (this.channel.ads.programSafeZoneLeft) {
          this.programSafeZoneLeft = this.channel.ads.programSafeZoneLeft % 60 === 0 ? this.channel.ads.programSafeZoneLeft / 60 : Number((this.channel.ads.programSafeZoneLeft / 60).toFixed(1))
        }
        if (this.channel.ads.programSafeZoneRight) {
          this.programSafeZoneRight = this.channel.ads.programSafeZoneRight % 60 === 0 ? this.channel.ads.programSafeZoneRight / 60 : Number((this.channel.ads.programSafeZoneRight / 60).toFixed(1))
        }
      },
      getChannelInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          ids: id,
          expand: 'auto_scheduler_rules',
        }
        const channelReq = this.$store.dispatch('channels', args)

        const distribArgs = {
          'channel.id': id,
        }
        const distribReq = this.$store.dispatch('assetDistributionByRules', distribArgs)

        return Promise.all([channelReq, distribReq])
          .then((res) => {
            const channels = res[0] || []
            if (channels.length == 0) {
              return
            }
            this.channel = processChannel(channels[0])

            this.channel.autoSchedulerDepthStr = this.durationShort(this.channel.autoSchedulerDepth)

            for (let i = 0; i < this.channel.autoSchedulerRules.length; i += 1) {
              const r = this.channel.autoSchedulerRules[i]
              r.desc = 'From ' + this.durationToStr(r.intervalStart, r.intervalEnd) + ' back'
              this.scheduleRules.push(r)
            }

            const distrib = res[1] || []
            const series = []
            for (let i = 0; i < distrib.length; i += 1) {
              const d = distrib[i]
              this.totalAssets += d.asset_count
              if (d.rule.id !== 0) {
                series.push(d.asset_count)
                const descr = this.durationToStrShort(d.rule.interval_start, d.rule.interval_end)
                this.chartOptions.xaxis.categories.push(descr)
              } else {
                this.outOfRules = d.asset_count
              }
            }
            this.chartOptions.series = [{ data: series }]
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      durationToStr (duration1, duration2) {
        const d1 = Math.floor(duration1 / 24)
        const h1 = duration1 - d1 * 24

        const d2 = Math.floor(duration2 / 24)
        const h2 = duration2 - d2 * 24

        let part1 = ''
        if (d1 > 0) {
          const suffix = d1 > 1 ? 's' : ''
          part1 = `${d1} day${suffix}`
        }
        let part2 = ''
        if (h1 > 0) {
          const suffix = h1 > 1 ? 's' : ''
          part2 = `${h1} hour${suffix}`
        }
        if (d1 === 0 && h1 === 0) {
          part2 = '0'
        }
        let part3 = ''
        if (d2 > 0) {
          const suffix = d2 > 1 ? 's' : ''
          part3 = `${d2} day${suffix}`
        }
        let part4 = ''
        if (h2 > 0) {
          const suffix = h2 > 1 ? 's' : ''
          part4 = `${h2} hour${suffix}`
        }
        return `${part1} ${part2} to ${part3} ${part4}`
      },
      durationShort (duration) {
        const d = Math.floor(duration / (24 * 60))
        const h = Math.floor((duration - d * 24 * 60) / 60)
        const m = duration - d * 24 * 60 - h * 60

        let res = ''
        if (d > 0) {
          const suffix = d > 1 ? 's' : ''
          res += `${d} day${suffix} `
        }
        if (h > 0) {
          const suffix = h > 1 ? 's' : ''
          res += `${h} hour${suffix} `
        }
        if (m > 0) {
          const suffix = m > 1 ? 's' : ''
          res += `${m} minute${suffix} `
        }
        return res
      },
      durationToStrShort (duration1, duration2) {
        const d1 = Math.floor(duration1 / 24)
        const h1 = duration1 - d1 * 24

        const d2 = Math.floor(duration2 / 24)
        const h2 = duration2 - d2 * 24

        if (d1 === 0 && d2 === 0) {
          const suffix = h2 > 1 ? 's' : ''
          return `${h1}-${h2} hour${suffix}`
        }
        if (d1 > 0 && d2 > 0 && h1 === 0 && h2 === 0) {
          const suffix = d2 > 1 ? 's' : ''
          return `${d1}-${d2} day${suffix}`
        }
        if (d1 === 0 && d2 > 0 && h1 > 0 && h2 === 0) {
          const suffix = d2 > 1 ? 's' : ''
          return `${h1}h-${d2} day${suffix}`
        }
        return ''
      },
      showPreSaveMsg () {
        this.preSaveMsg = true
      },
      openEditForm () {
        this.initSettings()
        this.dialog = true
      },
      adsToJson () {
        const processed = {
          in_content_advertising: false,
          ad_block_duration: 0,
          min_interval: 3 * 60,
          program_safe_zone_left: 0,
          program_safe_zone_right: 0,
        }
        if (!this.advertising) {
          return processed
        }
        processed.ad_block_duration = this.adBlockDuration * 60
        processed.min_interval = this.minInterval * 60
        if (this.inContentAdvertising) {
          processed.in_content_advertising = true
          processed.program_safe_zone_left = this.programSafeZoneLeft * 60
          processed.program_safe_zone_right = this.programSafeZoneRight * 60
        }
        return processed
      },
      saveEditForm () {
        if (!this.isFormValid) return
        this.isSaving = true

        this.$store.commit('setPageLoader')

        const requests = [
          this.$store.dispatch('setAds', {
            channelId: this.channel.id,
            ads: this.adsToJson(),
          }),
        ]
        if (this.updateSchedule === 'all') {
          requests.push(this.$store.dispatch('clearSchedule', { channel_id: this.channel.id }))
        }

        return Promise.all(requests)
          .then(() => {
            this.getChannelInfo(this.channel.id)
            this.$store.commit('showSnackbar', {
              text: 'New settings has been successfully saved',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
            this.isSaving = false
            this.dialog = false
            this.preSaveMsg = false
          })
      },
      closeDialog () {
        this.dialog = false
      },
    },
  }
</script>

<style>
</style>
